import {Transformer} from "./types/transformer";

export function fallbackValidation<T, K>(defaultVal: K, errorHandler: ((error: any, fallbackValue: K) => void) = console.error, ...transformers: Array<Transformer<any, any>>): (val: T) => K {

    //memoized last accepted value
    let retVal: K = defaultVal;

    const transformer: Transformer<T, K> = transformers.reduce( (acc, cur) => {
        return (val: any) => cur(acc(val));
    }, (val: T) => val );

    return (val: T) => {

        try {

            const transformedVal = transformer(val);

            //transformed successfully, save it as last accepted value
            retVal = transformedVal;

            return transformedVal;

        } catch (e) {

            errorHandler(e, retVal);

            //transform resulted to error return last accepted value
            return retVal;

        }
    }
}